import React from "react";
import HomeLayout from "../layouts/HomeLayout";

export default function ErrorPage() {
  return (
    <HomeLayout>
      <h1>404 - Page not found</h1>
    </HomeLayout>
  );
}
